<immutable-value-popup [id]="popupIdentifier"
                       [headerText]="headerText"
                       [caption]="caption"
                       [description]="description"
                       [icon]="icon" >
</immutable-value-popup>